import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { combineLatest, map } from 'rxjs';
import { UserPermission } from '../constants/permission.constants.enum';
import { DowntimeService } from '../services/downtime.service';
import { UserService } from '../services/user.service';

export const downtimeGuard: CanActivateFn = () => {

  const downtime = inject(DowntimeService);
  const user = inject(UserService);
  const router = inject(Router);

  return combineLatest([downtime.downtime$, user.permission$]).pipe(
    map(([d, p]) => {
      const isAdmin = p.includes(UserPermission.MedNecScreen_ISAdmin) || p.includes(UserPermission.MedNecScreen_Quorum_ISAdmin);
      if (!isAdmin && !d.isDown) {
        return router.parseUrl('/');
      }
      return true;
    })
  );
};
